import { FC } from "react";
import { Box } from "../../../../../components/box";
import { getUnitFromUnitID } from "../../../human-organization/summary-employee-request/utils/render-helper";


export const RecallToolInformation: FC<{ detail: any }> = ({ detail }) => {

  return (
    <Box title="Thông tin thu hồi CCDC">
      <div className="list">
        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Người yêu cầu</p>
            <strong>{detail?.createdBy?.user?.displayName}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Cơ quan/Đơn vị</p>
            <strong>{detail?.fields?.eDepartment}</strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100"> Đơn vị</p>
            <strong>
              {getUnitFromUnitID(
                detail?.fields?.eDepartment,
                detail?.fields?.eUnit
              )}
            </strong>
          </div>
        </div>

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100"> Số điện thoại</p>
            <strong>{detail?.fields?.ePhoneNumber}</strong>
          </div>
        </div>
      </div>
    </Box>
  );
};
